"use client";

import { createContext, use } from "react";

import { LotShipmentDescriptionData } from "@/components/ui/lot-number-details";

export interface LotSelectionRow {
  id: string;
  label: string;
  details?: LotShipmentDescriptionData & {
    lotNumber?: string;
    medicationName?: string | null;
  };
  disabled: boolean;
}

export interface LotSelectionValue {
  state: {
    selected: LotSelectionRow[];
    available: LotSelectionRow[];
    search: string;
    showDepleted: boolean;
  };
  actions: {
    select(id: string): void;
    remove(id: string): void;
    setSearch(value: string): void;
    setShowDepleted(value: boolean): void;
  };
  meta: {
    listId: string;
    productName?: string | null;
    locationNames: Record<string, string>;
    selection?: { accessibleLabelPrefix: string };
  };
}

export const LotSelectionContext = createContext<LotSelectionValue | null>(
  null,
);
const LotSelectionRowContext = createContext<LotSelectionRow | null>(null);

export function useLotSelection() {
  const context = use(LotSelectionContext);
  if (!context) throw new Error("Lot selection requires LotSelection.Provider");
  return context;
}

export function useLotSelectionRow() {
  const row = use(LotSelectionRowContext);
  if (!row)
    throw new Error("Lot row controls require LotSelection.SelectedRows");
  return row;
}

export const LotSelectionRowProvider = LotSelectionRowContext.Provider;
